const NEWSLETTER_ENDPOINT = '/api/newsletter'

export async function subscribeToNewsletter(email: string) {
  const formData = new FormData()
  formData.set('email', email)
  formData.set('consent', 'yes')

  const response = await fetch(NEWSLETTER_ENDPOINT, {
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
    },
  })

  const result = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(result?.message || 'Could not subscribe right now.')
  }

  return typeof result?.message === 'string' ? result.message : 'You are on the list.'
}
